import styled from "styled-components";

export const AdminAppStyled = styled.div`
  min-height: 100vh;
  background: #FFFCF3;
  position: relative;
`;
